/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { Labeled } from 'react-admin';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import { withStyles } from '@material-ui/core/styles';
import FileSaver from 'file-saver';
import request from 'superagent';
import _ from 'lodash';

const styles = (theme) => ({
  button: {
    margin: theme.spacing(),
  },
  extendedIcon: {
    marginRight: theme.spacing(),
  },
});

class DownloadPreviewsButton extends React.Component {
  async downloadOne(preview) {
    const res = await request
      .get(preview.url + '?format=png')
      .responseType('blob');

    const assetTitle = this.props.record.title;
    const assetId = this.props.record.id;
    FileSaver.saveAs(res.body, `${assetTitle}-${assetId}-${preview.label}.png`);
  }

  async downloadAll(previews) {
    await _.map(previews, (preview) => this.downloadOne(preview));
  }

  handleClick = () => {
    const previews = this.props.record[this.props.source];
    const thumbnail = this.props.record.thumbnail;
    this.downloadAll([{ ...thumbnail, label: 'thumbnail' }, ...previews]);
  };

  render() {
    const { classes } = this.props;
    return (
      <Labeled label="Download all preview images">
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={this.handleClick}
        >
          <SaveIcon className={classes.extendedIcon} />
          Download
        </Button>
      </Labeled>
    );
  }
}

export default withStyles(styles)(DownloadPreviewsButton);
